import axios from 'axios';

export const getTimezones = async (useOnlyLegacySupportedTimeZones) => {
  try {
    const response = await axios.get(`/timezone?useOnlyLegacySupportedTimeZones=${useOnlyLegacySupportedTimeZones}`);
    const result = response?.data ?? [];
    return result;
  } catch (error) {
    throw new Error(`Error fetching timezones : ${error?.message}`);
  }
};
